import createActionType from "../../utils/createActionType";

export const MODULE = "workflow/child-card-filter";

export const SET_SHOW_CHILD_CARDS = createActionType(MODULE, "setShowChildCards");

export const RESET = createActionType(MODULE, "reset");
